export default __webpack_public_path__ + "static/media/13.1b47e0ec.jpg";